export default __webpack_public_path__ + "static/media/kitemark.3a9e6401.svg";